import styled from 'styled-components';
import { ColorAddiCompFiveLighten4, ColorAddiWhite } from '@addi/foundation/dist/web/colors';
import { SizeAddiFontXSmall } from '@addi/foundation/dist/web/sizes';
import { PrimaryFont } from '../../typographies';
import { FontAddiWeightBold } from '@addi/foundation/dist/web/fonts';
export const ImageFlag = styled.img `
  max-width: 20px;
  display: inline-block;
  border-style: none;
  z-index: -1;
`;
export const TextFlag = styled.span `
  ${PrimaryFont}
  font-weight: ${FontAddiWeightBold};
  font-size: ${SizeAddiFontXSmall};
  padding-top: 3px;
  display: inline-block;
  padding-left: 6px;
`;
export const CountryList = styled.div `
  position: absolute;
  background-color: ${ColorAddiWhite};
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgb(0 0 0 / 20%);
  right: -30px;
  top: 30px;
  z-index: 100 !important;
`;
export const CountryItem = styled.div `
  padding: 15px;
  display: flex;
  max-height: 57px;
  cursor: pointer;
  :hover {
    background-color: ${ColorAddiCompFiveLighten4};
  }
  > img {
    z-index: 0;
  }
`;
//# sourceMappingURL=country-components.styled.js.map